import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiDatabase, FiAlertTriangle } from 'react-icons/fi';
import './EditorConnectionChip.css';
// 제목줄 칩 모양은 오라클 전문가 창의 연결 탭과 한 벌(monitoring/ConnTabsWindow.css 의 conntabs-inheader)
import '../monitoring/ConnTabsWindow.css';

/**
 * 편집기 탭의 연결을 보여 주는 제목줄 칩 — 편집기에 SQL 을 넣는 작업 화면(데이터 분석 · SQL 빌더)이 쓴다(2026-10-28).
 * **고르지 않는다**: 만든 SQL 은 SQL 편집 탭의 세션에서 실행되므로, 여기서 다른 연결을 고르면 그 연결의 테이블로 만든 SQL 이
 * 다른 DB 의 편집기에 들어간다(사용자 지적). 연결은 SQL 편집 탭에서 바꾼다.
 */
export default function ConnectionChip({ connections, value }) {
  const { t } = useTranslation();
  const cur = value ? ((connections || []).find(c => c.id === value) || { id: value }) : null;
  return (
    <div className="conntabs conntabs-inheader conn-chip-head">
      {cur ? (
        <div className="conntabs-tab active" title={t('common:connSel.editorHint')}>
          <span className="conntabs-main"><FiDatabase size={12} aria-hidden="true" /> {cur.name || cur.id}</span>
        </div>
      ) : (
        <div className="conntabs-tab conn-chip-none" title={t('common:connSel.noneHint')} role="status">
          <span className="conntabs-main"><FiAlertTriangle size={12} aria-hidden="true" /> {t('common:connSel.noEditorConn')}</span>
        </div>
      )}
    </div>
  );
}
ConnectionChip.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.object),
  /** SQL 편집 탭(활성 편집기 탭)의 연결 id */
  value: PropTypes.string,
};
